import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface PlatformAdmin {
  id: string
  email: string
  name: string
}

interface PlatformState {
  token: string | null
  admin: PlatformAdmin | null
  isPlatformAuthed: boolean
  setPlatform: (token: string, admin?: PlatformAdmin | null) => void
  setAdmin: (admin: PlatformAdmin) => void
  logout: () => void
}

/** Separate from the org-user auth store: a super-admin is not a tenant user. */
export const usePlatformStore = create<PlatformState>()(
  persist(
    (set) => ({
      token: null,
      admin: null,
      isPlatformAuthed: false,
      setPlatform: (token, admin) => set({ token, admin: admin ?? null, isPlatformAuthed: true }),
      setAdmin: (admin) => set({ admin }),
      logout: () => set({ token: null, admin: null, isPlatformAuthed: false }),
    }),
    { name: 'platform-auth' },
  ),
)
